import React from 'react';
import { Menu } from 'lucide-react';
import { useSidebar } from '../ui/sidebar';

/**
 * Phone menu bar for frames without the tab bar (accounts still finishing
 * signup): a 44px button that opens the navigation drawer.
 */
export const SidebarMobileTrigger = () => {
	const { isMobile, openMobile, toggleSidebar } = useSidebar();

	if (!isMobile) {
		return null;
	}

	return (
		<div className="flex h-11 shrink-0 items-center border-b border-border/60 bg-background px-1">
			<button
				type="button"
				onClick={toggleSidebar}
				aria-label="Menu"
				aria-expanded={openMobile}
				aria-haspopup="dialog"
				data-sidebar="trigger"
				data-onboarding="mobile-navigation"
				className="inline-flex size-11 items-center justify-center rounded-full text-foreground active:bg-accent"
			>
				<Menu className="size-[22px]" />
			</button>
		</div>
	);
};
